<template>
  <div class="details-reader-object">
    <template v-if="withAccordion">
      <a-collapse
        expand-icon-position="right"
        accordion>
        <a-collapse-panel
          :header="detailsKey | readableCamelCase | formatCommonAbbreviations">
          <div :key="`${_uid}-${detailsKey}-nested`">
            <details-reader
              :formatters="formatters"
              :copyable="copyable"
              :shortable="shortable"
              :details="detailsValue" />
          </div>
        </a-collapse-panel>
      </a-collapse>
    </template>

    <template v-else>
      <h3 class="details-reader__title">
        {{ detailsKey | readableCamelCase | formatCommonAbbreviations }}:
      </h3>

      <div :key="`${_uid}-${detailsKey}-nested`">
        <details-reader
          :formatters="formatters"
          :copyable="copyable"
          :details="detailsValue" />
      </div>
    </template>
  </div>
</template>

<script>

import ACollapse from 'ant-design-vue/lib/collapse/Collapse'
import ACollapsePanel from 'ant-design-vue/lib/collapse/CollapsePanel'
import 'ant-design-vue/lib/collapse/style/index.css'

export default {
  name: 'details-reader-object',

  components: {
    DetailsReader: () => import('./DetailsReader'),
    'a-collapse': ACollapse,
    'a-collapse-panel': ACollapsePanel,
  },
  props: {
    detailsKey: {
      type: [String, Number],
      required: true,
    },
    detailsValue: {
      type: [Object],
      required: true,
    },
    withAccordion: {
      type: Boolean,
      default: false,
    },
    copyable: {
      type: Boolean,
      default: false,
    },
    shortable: {
      type: Boolean,
      default: false,
    },
    formatters: {
      type: [Array],
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
@import './details-reader';
</style>
